import { Box, Button, styled } from "@mui/material";

export const TableColumnHeaderWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  minWidth: 0, 
  padding: "0 8px", 

  "& .MuiTypography-root": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    flexShrink: 1,
  },

  "& .MuiButton-root": {
    flexShrink: 0,
    minWidth: "auto",
    padding: 0, 
  },
});

export const SearchBarButtonContainerStyling = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    width: "auto", 
    height: "45px", 
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: "6px", 
    padding: "5px",
    marginLeft: "auto",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", 
    backgroundColor: theme.palette.background.paper, 
    transition: "all 0.3s ease-in-out",
    justifyContent: "flex-start",
    gap: "5px", 
    maxWidth: "fit-content", 
    "& button": {
      margin: "0 4px",
      "&:disabled": {
        color: theme.palette.grey[500],
        pointerEvents: "none",
      },
    },
  }))
  
  export const SaveButton = styled(Button)(({ theme }) => ({
    width: "40px",
    height: "40px",
    minWidth: "40px",
    padding: "8px",
    fontSize: "1.25rem",
    lineHeight: "1.2",
    fontWeight: "700",
    textAlign: "center",
    borderRadius: "5px",
    border: `1px solid ${theme.palette.companyMain.main}`,
    backgroundColor: theme.palette.companyMain.main,
    color: theme.palette.backgroundColor.main,
    textTransform: "none",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.companyMain.hover,
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }));
